'use strict';
(function () {
    var _ = require('lodash'),
        Event = require('./event'),
        EventDispatcher = require('./eventdispatcher');
    // private methods

    var _started = false;

    var _onStart = function (x, y) {
        },
        _onMove = function (x, y) {
            var e;
            if (this.position.x === undefined && this.position.y === undefined) {
                this.position.x = x;
                this.position.y = y;
                return;
            }
            if (this.position.x === x && this.position.y === y) {
                return;
            } else if (!_started) {
                this.position.x = x;
                this.position.y = y;
                e = new Event('pan-start');
                e.data = this.position;
                this.dispatchEvent(e);
                _started = true;
            }

            if (!_started) {
                return;
            }

            var deltaX = x - this.position.x;
            var deltaY = y - this.position.y;

            this.position.x = x;
            this.position.y = y;

            e = new Event('pan');
            e.data = {
                x: deltaX,
                y: deltaY,
                positionX:x,
                positionY:y
            };

            this.dispatchEvent(e);
        },
        _onEnd = function (x, y) {

            _started = false;

            this.position.x = x;
            this.position.y = y;

            var e = new Event('pan-end');
            e.data = this.position;
            this.dispatchEvent(e);

            this.position = {
                x: undefined,
                y: undefined
            };

        };

    var Controls = function Controls(boundTo) {
        this.position = {
            x: undefined,
            y: undefined
        };
        if (boundTo !== undefined) {
            this.boundTo = boundTo.length !== undefined ? boundTo : [boundTo];
        }
        _.bindAll(this);
        EventDispatcher.call(this);
    };

    Controls.prototype = _.extend({
        enable: function () {
            this._addEventListeners();
        },
        disable: function () {
            this._removeEventListeners();
        },

        _addEventListeners: function () {
            if (this.boundTo !== undefined) {
                _.each(this.boundTo, function (el) {
                    el.addEventListener('mousedown', this._onMouseDown);
                    el.addEventListener('touchstart', this._onTouchStart);
                }, this);
            } else {
                document.addEventListener('mousedown', this._onMouseDown);
                document.body.addEventListener('touchstart', this._onTouchStart);
            }

        },

        _removeEventListeners: function () {
            document.removeEventListener('mousedown', this._onMouseDown);
            document.body.removeEventListener('touchstart', this._onTouchStart);

            this._onMouseUp(null);
            this._onTouchEnd(null);
        },

        _onMouseDown: function (e) {
            e.stopImmediatePropagation();
            e.preventDefault();
            document.addEventListener('mouseup', this._onMouseUp);
            document.addEventListener('mousemove', this._onMouseMove);
            _.bind(_onStart, this)(e.clientX, e.clientY);
        },

        _onMouseUp: function (e) {
            if (e) {
                e.preventDefault();
            } else {
                return;
            }
            _.bind(_onEnd, this)(e.clientX, e.clientY);
            this.dispatchEvent(new Event('release'));
            document.removeEventListener('mouseup', this._onMouseUp);
            document.removeEventListener('mousemove', this._onMouseMove);

        },

        _onMouseMove: function (e) {
            e.stopImmediatePropagation();
            e.preventDefault();
            _.bind(_onMove, this)(e.clientX, e.clientY);
        },

        _onTouchStart: function (e) {
            document.body.addEventListener('touchend', this._onTouchEnd);
            document.body.addEventListener('touchmove', this._onTouchMove);
            _.bind(_onStart, this)(e.touches.item(0).clientX, e.touches.item(0).clientY);
        },

        _onTouchEnd: function (e) {
            this.dispatchEvent(new Event('release'));
            document.body.removeEventListener('touchend', this._onTouchEnd);
            document.body.removeEventListener('touchmove', this._onTouchMove);
            _.bind(_onEnd, this)(this.position.x, this.position.y);
        },

        _onTouchMove: function (e) {
            _.bind(_onMove, this)(e.touches.item(0).clientX, e.touches.item(0).clientY);
        }

    }, EventDispatcher.prototype);

    module.exports = Controls;
}());


/** WEBPACK FOOTER **
 ** ./holiday-map/util/controls.js
 **/